import styled from '@emotion/styled';
import { BodySmall, Center } from '@dh/styles';
import { shouldForwardProps } from '@dh/utils';

import { AppLogo } from '../svgs';

const ErrorBox = styled(Center)`
    min-height: 100vh;
    max-width: 480px;
    text-align: center;
`;

const ErrorImage = styled(AppLogo)`
    width: 295px;
    height: 295px;
    margin-bottom: ${({ theme }) => theme.spacing(5)};
    margin-top: ${({ theme }) => theme.spacing(5)};
`;

const ErrorHint = styled(BodySmall, shouldForwardProps)`
    color: ${({ theme }) => theme.colors.error};
`;

export { ErrorImage, ErrorBox, ErrorHint };
